import { render, staticRenderFns } from "./btnContrast.vue?vue&type=template&id=45fef3b3&scoped=true"
import script from "./btnContrast.vue?vue&type=script&lang=js"
export * from "./btnContrast.vue?vue&type=script&lang=js"
import style0 from "./btnContrast.vue?vue&type=style&index=0&id=45fef3b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fef3b3",
  null
  
)

export default component.exports